import RequestService from "../util/request";
import {environment, getOnlineServices} from "../util";
import { IADPState } from "../Types/AppStateTypes";
import { HeartBeat } from "../Types/ServiceTypes";
let intervalId: any = undefined;
let numberOfHeartbeatPending = 0;
const HeartbeatService = {
    post:async ( state:IADPState, cb?:any)=>{
       if(!state.sessionState.schoolDetails?.setupCode) return;
        const payload : HeartBeat = {
            clientLaunchId: state.appState.appLaunchId as string,
            setupCode: state.sessionState.schoolDetails?.setupCode?.toUpperCase() as string,
            deviceId: state.deviceState.deviceId as string,
            loginId: "NA"
        }
        
        const url = `${environment.resolveApiDomain(state.appState.configuration)}/${getOnlineServices(state.appState.configuration)?.heartbeatAsync}`
        RequestService.postHeartbeat(payload,url as string,cb);   
    },
init: (state: IADPState, interval?: number)=>{
    numberOfHeartbeatPending++;
    const callback = () => {
        numberOfHeartbeatPending--;
     } 
    HeartbeatService.post(state,callback);
    if (typeof intervalId=== 'number') {
        console.log(`[Heartbeat Service][Clearing interval] ${intervalId}`);
        clearInterval(intervalId);
      }
      intervalId = setInterval(()=>{
        if(numberOfHeartbeatPending > 0) return;
         const callback = () => {
            numberOfHeartbeatPending--;
         }
         numberOfHeartbeatPending++;   
         HeartbeatService.post(state,callback);
      },interval ? interval : (state.appState.configuration?.heartbeatIntervalSec || 10 )*1000)
},
cancelHeartbeat: ()=>{
    if (typeof intervalId=== 'number') {
        console.log(`[Heartbeat Service][Canceling Heartbeat] ${intervalId}`);
        clearInterval(intervalId);
      }
}
}
export default HeartbeatService;